import type { Location } from "~/core/ts/entity/Location"
import type { Treatment } from "~/core/ts/entity/Treatment"
import HeadMetaBuilder from "~/core/ts/util/HeadMetaBuilder"
import { capitalizeAllLargeWords } from "~/core/ts/util/string"
import { translate } from "~/core/ts/util/translate"

export function getTreatmentMetadata(
  url: string,
  treatment: Treatment,
  location?: Location | undefined | null,
  imageUrl?: string | undefined | null,
) {
  const { pageHeadTitle, metaDescription, metaTitle } = getTitleAndDescription(treatment, location)

  const combtitle = pageHeadTitle + ' | Spalopia.com'

  const builder = HeadMetaBuilder.create()
    .withTitle(combtitle)
    .withMetaTitle(metaTitle)
    .withMetaDescription(metaDescription)
    .withOpenGraphMeta(combtitle, metaDescription)
    .withTwitterMeta(combtitle, metaDescription)
    .withLink('canonical', url)

  if (imageUrl) {
    builder
      .withTwitterImage(imageUrl)
      .withOpenGraphImage(imageUrl)
      .withThumbnailImage(imageUrl)
  }

  return builder.get()
}

export function getTitleAndDescription(treatment: Treatment, location: Location | undefined | null) {
  let pageHeadTitle = {
    es: 'Tratamientos',
    pt: 'Tratamentos',
  }
  let metaDescription ={
    es: 'Encuentra las mejores experiencias de Spa en España: Circuito Spa, Spa y Masaje, Spa y Brunch, Spa y Hotel... ¡Todo lo que necesitas para descansar!',
    pt: 'Encontre as melhores experiências de Spa em Espanha: Circuito de Spa, Spa e Massagem, Spa e Brunch, Spa e Hotel... Tudo o que precisa para relaxar!',
  }
  if (treatment) {
    pageHeadTitle = {
      es: `Experimenta los beneficios de un ${treatment.title}${location ? ` en ${location.label}` : ''} y reserva online`,
      pt: `Experimente os benefícios de um ${treatment.title}${location ? ` em ${location.label}` : ''} e reserve online`,
    }
    metaDescription = {
      es: `¿Sabes qué es un ${treatment.title} y sus beneficios? Desde Spalopia podrás reservar este servicio en spas y balnearios de tu zona.`,
      pt: `Sabe o que é uma ${treatment.title} e quais os seus benefícios? A partir da Spalopia pode reservar este serviço em spas e termas da sua zona.`,
    }
  }

  const treatTitle = capitalizeAllLargeWords(translate(treatment.texts).title)

  const title = location ? `${treatTitle} en ${location.label}` : treatTitle

  const meta = {
    // Título usado en <title></title>
    pageHeadTitle: translate(pageHeadTitle),

    title,
    metaTitle: title,

    metaDescription: translate(metaDescription),
  }

  return meta
}
